<div class="modal-header">
  <h4 class="modal-title">{{ "Log in" | translate }}</h4>
  <button (click)="activeModal.dismiss('Cross click')" class="close" aria-label="Close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <astrobin-login-form #loginForm (loginSuccessful)="activeModal.close()"></astrobin-login-form>
</div>

<div class="modal-footer">
  <ng-container *ngIf="(currentUser$ | async) === null">
    <button
      [class.loading]="loadingService.loading$ | async"
      [disabled]="!loginForm.form.valid || (loadingService.loading$ | async)"
      (click)="loginForm.login()"
      class="btn btn-primary"
    >
      {{ "Log in" | translate }}
    </button>

    <a (click)="activeModal.dismiss()" class="btn btn-secondary" routerLink="/account/register">
      {{ "Sign up" | translate }}
    </a>

    <a (click)="activeModal.dismiss()" class="btn btn-secondary" routerLink="/account/password-reset">
      {{ "Reset password" | translate }}
    </a>
  </ng-container>
</div>
